import React, { FC, useEffect, useState } from 'react';
import { ReactComponent as ExportOrdersIcon } from 'assets/icons/document-upload.svg';
import {
  BaseModal,
  Button,
  DateRangeSelector,
  ENUM_DATE_RANGE,
  Input,
  ToastMessage,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
import { STORAGE_KEYS } from 'utils/constants';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';

interface ExportOrdersModalType {
  show: boolean;
  onClose: () => void;
}

interface ExportOrdersModalFooterType {
  loading: boolean;
  onConfirm: () => void;
}

const ExportOrdersModalFooter: FC<ExportOrdersModalFooterType> = ({ onConfirm, loading }) => (
  <Button
    small
    color='primary'
    variant='block'
    className='mx-auto'
    loading={loading}
    onClick={onConfirm}>
    Confirm
  </Button>
);

const ExportOrdersModal: FC<ExportOrdersModalType> = ({ show, onClose }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [emailAddress, setEmailAddress] = useState('');
  const [dateRange, setDateRange] = useState(getDateRangeSelector(ENUM_DATE_RANGE.ALL));

  useEffect(() => {
    if (show) {
      const defaultEmail = localStorage.getItem(STORAGE_KEYS.EMAIL);
      setEmailAddress(defaultEmail ?? '');
      setDateRange(getDateRangeSelector(ENUM_DATE_RANGE.ALL));
    }
  }, [show]);

  const sendDetails = async () => {
    try {
      setLoading(true);
      await apiService.post('logistics/order-history/export', {
        data: {
          email: emailAddress,
          start_date: dateRange.startDate,
          end_date: dateRange.endDate
        },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Order history sent' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title='Export Orders'
      description='Provide your mail address to have orders sent to your mail'
      titleIcon={<ExportOrdersIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={<ExportOrdersModalFooter loading={loading} onConfirm={sendDetails} />}>
      <div className='space-y-3'>
        <Input
          label='Email Address'
          placeholder='paul@gmail.com'
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.target.value)}
          name='emailAddress'
        />
        <div>
          <p className='font-medium text-base mb-2'>Duration</p>
          <DateRangeSelector
            defaultRange={ENUM_DATE_RANGE.ALL}
            onChange={(v) => setDateRange(v.date)}
            className='py-5 text-base border-gray-6'
            isInput
            showTime
          />
        </div>
      </div>
    </BaseModal>
  );
};

export default ExportOrdersModal;
